import CoursewareBlockAdderArea from './CoursewareBlockAdderArea.vue';
import CoursewareCollapsibleBox from './CoursewareCollapsibleBox.vue';
import CoursewareCompanionBox from './CoursewareCompanionBox.vue';
import CoursewareDefaultBlock from './CoursewareDefaultBlock.vue';
import CoursewareDefaultContainer from './CoursewareDefaultContainer.vue';
import CoursewareFileChooser from './CoursewareFileChooser.vue';
import CoursewareTabs from './CoursewareTabs.vue';
import CoursewareTab from './CoursewareTab.vue';

const CoursewarePluginComponents = {
    CoursewareBlockAdderArea,
    CoursewareCollapsibleBox,
    CoursewareCompanionBox,
    CoursewareDefaultBlock,
    CoursewareDefaultContainer,
    CoursewareFileChooser,
    CoursewareTabs,
    CoursewareTab,
}

export default CoursewarePluginComponents;